import React from 'react';

// ── Toast ──────────────────────────────────────────────────────────
export function ToastContainer({ toasts }) {
  return (
    <div className="toast-wrap">
      {toasts.map(t => (
        <div key={t.id} className={`toast toast-${t.tipo}`}>{t.mensaje}</div>
      ))}
    </div>
  );
}

// ── Spinner ────────────────────────────────────────────────────────
export function Spinner({ texto }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '.6rem', color: 'var(--gris-4)', padding: '1rem 0' }}>
      <div className="spinner" />
      {texto && <span>{texto}</span>}
    </div>
  );
}

// ── Stepper ────────────────────────────────────────────────────────
export function Stepper({ actual, total = 4, labels = ['Cliente', 'Servicios', 'Escaneo', 'Revisión'] }) {
  const pasos = labels.slice(0, total).map((label, i) => ({ n: i + 1, label }));
  return (
    <div className="stepper">
      {pasos.map((p, i) => (
        <React.Fragment key={p.n}>
          <div className="step-item">
            <div className={`step-circle ${p.n < actual ? 'done' : p.n === actual ? 'active' : ''}`}>
              {p.n < actual ? '✓' : p.n}
            </div>
            <span className={`step-label ${p.n === actual ? 'active' : ''}`}>{p.label}</span>
          </div>
          {i < pasos.length - 1 && (
            <div className={`step-line ${p.n < actual ? 'done' : ''}`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

// ── Badge ──────────────────────────────────────────────────────────
const statusMap = {
  borrador:   ['badge-naranja', 'Borrador'],
  abierta:    ['badge-azul',    'Abierta'],
  cerrada:    ['badge-verde',   'Cerrada'],
  entregada:  ['badge-verde',   'Entregada'],
  cancelada:  ['badge-rojo',    'Cancelada'],
  aprobado:   ['badge-verde',   'Aprobado'],
  pendiente:  ['badge-naranja', 'Pendiente'],
  ejecutado:  ['badge-verde',   'Ejecutado'],
  completado: ['badge-verde',   'Completado'],
  rechazado:  ['badge-rojo',    'Rechazado'],
  abierto:    ['badge-azul',    'Abierto'],
};

export function StatusBadge({ status }) {
  const [cls, label] = statusMap[status] || ['badge-gris', status];
  return <span className={`badge ${cls}`}>{label}</span>;
}

// ── Empty state ────────────────────────────────────────────────────
export function Empty({ icon = '📋', texto = 'Sin resultados' }) {
  return (
    <div className="empty">
      <div className="empty-icon">{icon}</div>
      <p>{texto}</p>
    </div>
  );
}

// ── Confirm dialog simple ──────────────────────────────────────────
export function ConfirmModal({ mensaje, onConfirm, onCancel, textoConfirmar = 'Confirmar' }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,.4)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200
    }}>
      <div className="card" style={{ maxWidth: 360, width: '90%' }}>
        <p style={{ marginBottom: '1.25rem', lineHeight: 1.5 }}>{mensaje}</p>
        <div style={{ display: 'flex', gap: '.5rem', justifyContent: 'flex-end' }}>
          <button className="btn btn-secondary btn-sm" onClick={onCancel}>Cancelar</button>
          <button className="btn btn-danger btn-sm" onClick={onConfirm}>{textoConfirmar}</button>
        </div>
      </div>
    </div>
  );
}
